// Canonical odometer parsing for the marketplace entry form and the outreach chat's
// mileage step, both of which accept free-form text ("42,500", "42500 mi").
//
// Worth going through rather than re-deriving: `Number('')` is `0`, not `NaN`, so the
// obvious `Number(raw.replace(/[^0-9]/g, ''))` accepts pure garbage as a valid 0.

/** Well past any real odometer, tight enough to reject a pasted VIN or phone number. */
const MAX_MILEAGE = 1_000_000;

export function parseMileage(raw: string): number | null {
  const digits = raw.replace(/[^0-9]/g, '');
  if (digits === '') return null;
  const n = Number(digits);
  return n > MAX_MILEAGE ? null : n;
}
